import React from 'react';
import PurchaseCategoryManagement from '../components/PurchaseCategoryManagement';

const PurchaseCategories: React.FC = () => {
  return (
    <div className="p-6">
      <PurchaseCategoryManagement />
    </div>
  );
};

export default PurchaseCategories;
